/**
 * Форматирует российский номер телефона в UI-формат.
 *
 * Принимает номер в виде строки или числа, очищает его от лишних символов
 * и приводит к формату: `+7 (XXX) XXX-XX-XX`.
 *
 * Поддерживает номера, начинающиеся с `7` или `8`.
 * Например:
 *
 * - `79258792008` → `+7 (925) 879-20-08`
 * - `89258792008` → `+7 (925) 879-20-08`
 * - `+7 925 879 20 08` → `+7 (925) 879-20-08`
 *
 * Если значение пустое, возвращает пустую строку.
 * Если номер не соответствует ожидаемому формату российского номера,
 * возвращает исходное значение в виде строки.
 *
 * @param phone - Номер телефона для форматирования.
 * @returns Отформатированный номер телефона или исходное значение в виде строки.
 */
export function formatRuPhone(phone: string | number | null | undefined): string {
  if (!phone) return ''

  const digits = String(phone).replace(/\D/g, '')

  if (digits.length !== 11) return String(phone)

  const normalized = digits.startsWith('8') ? `7${digits.slice(1)}` : digits

  if (!normalized.startsWith('7')) return String(phone)

  return normalized.replace(/^7(\d{3})(\d{3})(\d{2})(\d{2})$/, '+7 ($1) $2-$3-$4')
}
